import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IonCard, IonCardContent } from "@ionic/react";
import Avatar from "../avatar/Avatar"; // Adjust import path if needed
import { getHashtagMembers } from "../../api/requests/hashtag";
import "./CommunityMembers.css";

const CommunityMembers = ({ tag, hashtagData }) => {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMembers = async () => {
      if (!tag) return;
      // setLoading(true);
      const response = await getHashtagMembers(tag);
      if (response && response.status === 200) {
        setMembers(response.data);
      }
      setLoading(false);
    };
    fetchMembers();
  }, [tag, hashtagData]);

  if (!members || members.length === 0) {
    if (loading) return <div style={{ height: "120px" }} />; // Keep the space!
    return null;
  }

  return (
    <IonCard className="community-members-card">
      <IonCardContent className="community-members-content">
        <div className="community-members-header">
          <span className="community-members-title">Members</span>
        </div>
        <div className="community-members-list">
          {members.map((member) => (
            <div key={member._id} className="community-member-item">
              <Avatar
                username={member.username}
                avatar={member.avatar}
                province={member.province}
                size="md"
                isAdmin={member.isCommunityAdmin}
                isOfficial={member.isAdmin}
              />
              <Link
                to={`/profile/${member.username}`}
                className={`member-name ${member.isAdmin ? "text-admin" : ""}`}
              >
                <span>{member.fname || member.username}</span>
              </Link>
            </div>
          ))}
        </div>
      </IonCardContent>
    </IonCard>
  );
};

export default CommunityMembers;
